// extracted by mini-css-extract-plugin
module.exports = {"root":"UploadCoverContent_root__2L4Bt","text":"UploadCoverContent_text__1MDSn"};